import type { DeliveryReceipt } from '../types.js'

export const CHANNEL_WORDS: Record<string, string> = { web_push: 'Pushed', email: 'Emailed', sms: 'Texted' }
export const CHANNEL_NOUN: Record<string, string> = { web_push: 'Push', email: 'Email', sms: 'Text message' }

export const RECEIPT_STATUS_LABEL: Record<DeliveryReceipt['status'], string> = { sent: 'sent', failed: 'failed', skipped: 'skipped', address_gone: 'address gone', opted_out: 'opted out', held: 'held' }
export const RECEIPT_STATUS_CLASS: Record<DeliveryReceipt['status'], string> = { sent: 'text-green', failed: 'text-coral', skipped: 'text-ink-mid', address_gone: 'text-coral', opted_out: 'text-ink-mid', held: 'text-gold' }

export function formatReceiptTime(iso: string): string {
  return new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

/** The carrier's word on a sent text, where it has come: " · delivered 9:07 PM" or " · not delivered · CARRIER_BLOCKED". */
export function describeProviderOutcome(receipt: DeliveryReceipt): string {
  const outcome = receipt.providerOutcome
  if (!outcome) {
    return ''
  }
  return outcome.status === 'delivered' ? ` · delivered ${formatReceiptTime(outcome.at)}` : ` · not delivered · ${outcome.description}`
}

/** "Pushed 9:07 PM", "Texted 9:07 PM · delivered 9:07 PM", "Text held until 7:00 AM" or "Email failed 9:07 PM · Email address is not verified". */
export function describeReceipt(receipt: DeliveryReceipt): string {
  const when = formatReceiptTime(receipt.at)
  if (receipt.status === 'sent') {
    return `${CHANNEL_WORDS[receipt.channel] ?? `Sent by ${receipt.channel}`} ${when}${describeProviderOutcome(receipt)}`
  }
  if (receipt.status === 'held') {
    const until = receipt.heldUntil ? ` until ${new Date(receipt.heldUntil).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}` : ''
    return `${CHANNEL_NOUN[receipt.channel] ?? receipt.channel} held${until} · quiet hours at the facility`
  }
  const noun = CHANNEL_NOUN[receipt.channel] ?? receipt.channel
  return `${noun} ${RECEIPT_STATUS_LABEL[receipt.status]} ${when}${receipt.reason ? ` · ${receipt.reason}` : ''}`
}
